let globalStyle = null;
const isClient = typeof window !== 'undefined';
export class Style {
    /**
     * 返回全局单例
     */
    static getInstance() {
        if (!Style.instance) {
            Style.instance = new Style();
        }
        return Style.instance;
    }
    /**
     * 追加样式
     */
    appendStyle(styleText) {
        if (!isClient) {
            return;
        }
        if (!globalStyle) {
            globalStyle = document.createElement('style');
            const head = document.getElementsByTagName('head')[0];
            head.appendChild(globalStyle);
        }
        try {
            globalStyle.appendChild(document.createTextNode(styleText));
        }
        catch (ex) {
        }
    }
    /**
     * 检查 var 是否存在
     * @param property
     * @returns
     */
    checkVarExists(property) {
        return isClient && !!window.getComputedStyle(document.documentElement).getPropertyValue(property);
    }
}
Style.instance = null;
